import React from 'react';
import { Col, Modal, Row, Button } from 'react-bootstrap';
import { TextBox } from 'fw/forms';
import { Label } from 'fw/components';
import API from 'fw/system/API';
import * as APIRoutes from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class TrackItPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            saving: false,
			codeValidated: false,

			certificationId: props.certificationId,
            isModifying: props.isModifying,

            trackingData: props.trackingData,
			discountCode: props.discountCode
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            saving: false,
			codeValidated: false,
            trackingData: nextProps.trackingData,
			discountCode: nextProps.discountCode
        });
    }

    urls() {
        return {
            trackCertification: APIRoutes.Admin.url('/certification/trackCertification'),
			validateDiscountCode: APIRoutes.DiscountCode.url('/discountCodeSetup/validateDiscountCode')
        }
    }

    // Track It is add-only for discount codes: if the certification already has a
    // code (from checkout or a previous Track It), the field is hidden and no code
    // is sent. Removing a code is done through the Untrack button.
    canEnterDiscountCode() {
        return !this.props.discountCode;
    }

    saveRequest() {
        return {
            certificationId: this.props.certificationId,
            trackingData: this.state.trackingData,
			discountCode: this.canEnterDiscountCode() ? this.state.discountCode : undefined
        };
    }

	validateDiscountCodeRequest() {
        return {
            certificationId: this.props.certificationId,
			discountCode: this.state.discountCode
        };
    }

	validateDiscountCode = () => {
        const me = this;
        const rq = this.validateDiscountCodeRequest();
        const url = this.urls().validateDiscountCode;

        new API().post(url, rq, {
            success: (r) => {
                Notifications.success(r.message);
                me.setState({ 
					codeValidated: true,
					discountCodeValid: true
				});
            },
            error: r => {
                me.setState({ 
					saving: false,
					codeValidated: true,
					discountCodeValid: false
				});
                Notifications.error(r.error.errorMessage);
            }
        })
    }

    confirm = () => {
        const me = this;
        const rq = this.saveRequest();
        const url = this.urls().trackCertification;

        new API().post(url, rq, {
            success: (r) => {
                Notifications.success(r.message);
                this.setState(this.initialState(this.props), () => {
                    this.props.onClose(r.data);
                });
            },
            error: r => {
                me.setState({ saving: false });
                Notifications.error(r.error.errorMessage);
            }
        })
    }

    close = () => {
        this.setState(this.initialState(this.props), () => {
            this.props.onClose({});
        });
    }

    handleChange = (v) => {
        this.setState({ trackingData: v });
    }

	handleDiscountCodeChange = (v) => {
        this.setState({ discountCode: v });
    }

    calculateRemainingCharacters = () => {
        const dataLength = this.state.trackingData.length

        return 50 - dataLength;
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Header>
                    <Modal.Title>{this.props.isModifying && "Modify "}Tracking Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
					{this.canEnterDiscountCode() ?
						<React.Fragment>
							<Row>
								<Col md={4}>
									<Label htmlFor="discountCode">Discount Code</Label>
								</Col>
							</Row>
							<Row>
								<Col md={8}>
									<TextBox
										name="discountCode"
										value={this.state.discountCode}
										onChange={this.handleDiscountCodeChange}
										placeholder="Enter Discount Code"
										maxLength={20} />
								</Col>
								<Col md={4}>
									<Button bsStyle="primary" disabled={this.state.saving} onClick={this.validateDiscountCode}>Verify</Button>
								</Col>
								<Col md={12} style={{ marginTop: "8px" }}>
									{this.state.codeValidated && this.state.discountCodeValid &&
										<React.Fragment>
											<FontAwesomeIcon icon={['fas', 'check']} size="lg" style={{ color: 'green', verticalAlign: 'middle', marginRight: '8px' }} className="my-icon" />
											<b style={{ color: 'green', verticalAlign: 'middle' }}>The code is valid</b>
										</React.Fragment>
									}
									{this.state.codeValidated && !this.state.discountCodeValid &&
										<React.Fragment>
											<FontAwesomeIcon icon={['fas', 'times']} size="lg" style={{ color: 'red', verticalAlign: 'middle', marginRight: '8px' }} className="my-icon" />
											<b style={{ color: 'red', verticalAlign: 'middle' }}>The code is NOT valid</b>
										</React.Fragment>
									}
								</Col>
							</Row>
						</React.Fragment>
						:
						<Row>
							<Col md={12}>
								<Label>Discount Code</Label>
								{this.props.isModifying ?
									<p style={{ marginTop: "5px" }}>
										Discount code <b>{this.props.discountCode}</b> is applied. Use the <b>Untrack</b> button to remove it.
									</p>
									:
									<p style={{ marginTop: "5px" }}>
										Discount code <b>{this.props.discountCode}</b> was applied at checkout and cannot be changed here.
									</p>
								}
							</Col>
						</Row>
					}
                    <Row style={{ marginTop: "20px" }}>
                        <Col md={12}>
                            <Label htmlFor="trackingData" required>Enter the tracking data here:</Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <TextBox
                                name="trackingData"
                                value={this.state.trackingData}
                                onChange={this.handleChange}
                                placeholder="Enter your tracking data"
                                maxLength={50}
                                required />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <p style={{ marginTop: "10px" }}>
                                {this.calculateRemainingCharacters()} Remaining Characters
                            </p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="link" onClick={this.close}>Cancel</Button>
                    <Button bsStyle="primary" disabled={this.state.saving} onClick={this.confirm}>{this.props.isModifying ? "Modify" : "Add Comment"} & Save</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default TrackItPopUp;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/TrackItPopUp.js